"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var config = {
  // key for a local storage
  tokensKey: 'tokens',
  remoteLogin: null,
  remoteRefreshTokens: null,
  detectShouldRefresh: null,
  remoteGetAuthUser: null,
  options: {}
};
var _default = config;
exports.default = _default;